/**
 * Vuelidate custom validator. Checks if file-input file is image (jpg/png)
 * @param {File} file 
 * @returns {boolean}
 */
export function isImage(file) {
  return !!file.type.match("image/jpg|image/jpeg|image/png");
}

/**
 * Resizes an image, prepares it for upload
 * Based on: https://stackoverflow.com/a/72728396/1515053
 * @param {File} file
 * @param {{ maxWidth: number, maxHeight: number }} dimensions
 * @returns {Promise<Blob>}
 */
export async function resizeImage(file, { maxWidth, maxHeight }) {
  // Ensure the file is an image
  if (!file.type.match(/image.*/)) return null;

  // Load image to figure out dimensions
  const image = new Image();
  image.src = URL.createObjectURL(file);
  await new Promise(resolve => (image.onload = resolve));

  const canvas = document.createElement("canvas");
  const context = canvas.getContext("2d", { alpha: true });

  // Draw image scaled on canvas element
  let width, height;
  if (image.width >= image.height && image.width > maxWidth) {
    const ratio = image.height / image.width; // 4/3
    width = maxWidth;
    height = maxWidth * ratio;
  } else if (image.height > image.width && image.height > maxHeight) {
    const ratio = image.width / image.height; // 4/3
    width = maxHeight * ratio;
    height = maxHeight;
  }
  canvas.width = width;
  canvas.height = height;
  context.drawImage(image, 0, 0, width, height);

  // Convert canvas to blob
  return new Promise(resolve => canvas.toBlob(resolve));
}
